import constants from './Constants'

const sunData = {
  radius: 432288 * constants.LENGTH_MILE, // https://en.wikipedia.org/wiki/Solar_radius
  axialTiltDeg: 7.25,
  description: "The sun is a white star around which Earth orbits. As such, it is hugely important in many aspects of our daily lives. Despite its color, the sun is often called a yellow dwarf. It has remained stable for over four billion years and will continue to do so for about five billion more. After this time, it will expand to become a red giant.",
  descriptionImage: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/The_Sun_by_the_Atmospheric_Imaging_Assembly_of_NASA%27s_Solar_Dynamics_Observatory_-_20100819.jpg/440px-The_Sun_by_the_Atmospheric_Imaging_Assembly_of_NASA%27s_Solar_Dynamics_Observatory_-_20100819.jpg",
  descriptionSource: "https://en.wikipedia.org/wiki/Sun",
};

export default sunData;